/**
 * Representation of the Exhibition Entity
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export { Exhibition };

import { ImageList } from './ImageList.js';

function Exhibition(modelRef, data) {

	let self = this;
	
	// Properties
	let model = modelRef;
	let id = data.id;
	let startDate = data.startDate;
	let active = 0;

	let nameDE = data.nameDE;
	let nameEN = data.nameEN;
	let nameFR = data.nameFR;

	let leadTextDE = data.leadTextDE;
	let leadTextEN = data.leadTextEN;
	let leadTextFR = data.leadTextFR;

	let descriptionDE = data.descriptionDE;
	let descriptionEN = data.descriptionEN;
	let descriptionFR = data.descriptionFR;

	let image = new ImageList(data.image);
	
	// Relations
	let tags = [];
	let works = [];
	
	// Basic Getters
	
	self.getID = function() {
		return id;
	}
	
	self.isActive = function() {
		return active;
	}

	self.setActive = function(isActive) {
		active = isActive;
	}

	self.getStartDate = function() {
		return startDate;
	}
	
	self.getName = function() {		
		if (model.getLang() == 'en') {
			return nameEN;
		} else if (model.getLang() == 'fr') {
			return nameFR;
		} else {
			return nameDE;
		}
	}
	
	self.getLeadText = function() {
		if (model.getLang() == 'en') {
			return leadTextEN;
		} else if (model.getLang() == 'fr') {
			return leadTextFR;
		} else {
			return leadTextDE;
		}
	}
	
	self.getDescription = function() {
		if (model.getLang() == 'en') {
			return descriptionEN;
		} else if (model.getLang() == 'fr') {
			return descriptionFR;
		} else {
			return descriptionDE;
		}
	}
	
	self.getImage = function() {
		
		// if the exhibition does not have an image, we use the first work with an image
		if (image.hasImages() == false) {
			for (let i = 0; i < works.length; i++) {
				if (works [i].getWork().getImages().hasImages()) {
					return works [i].getWork().getImages();
				}
			}
		}
		
		return image;
	}
	
	// Relations
	
	self.getTags = function() {
		return tags;
	}
	
	self.addTag = function(tag) {
		tags.push(tag);
	}
	
	self.getWorks = function() {
		return works;
	}
	
	self.getWorksByDisplaySort = function() {
		let array = [];
		for (let i = 0; i < works.length; i++) {
			array.push(works [i]);
		}
		
		array = array.sort(function(a, b) {
			return a.seqDisplay - b.seqDisplay;
		});
		return array;
	}
	
	self.getWorksByLinkSort = function() {
		let array = [];
		for (let i = 0; i < works.length; i++) {
			array.push(works [i]);
		}
		
		array = array.sort(function(a, b) {
			return a.seqDisplay - b.seqDisplay;
		});
		return array;
	}
	
	self.addWork = function(work) {
		works.push(work);
	}

	// Utilities

	/** Get the basic (unencoded) URL Term form for this entity */
	self.getURLTerm = function() {
		return nameDE.trim().replace(/ /g, "_").toLowerCase();		
	}

	/** Equality Test Used for URL Resovling */
	self.acceptURLTerm = function(term) {
		return this.getURLTerm() == term;
	}	
	
}